// @mcc-dev-preview file
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { StatusPageLayout } from '../components/layout/StatusPageLayout';
import type { StatusIconVariant } from '../components/layout/StatusIcon';

const VARIANTS: StatusIconVariant[] = ['warning', 'error', 'success', 'loading'];

const SAMPLES: Record<
  StatusIconVariant,
  { title: string; body: string; showActions?: boolean; showChildren?: boolean }
> = {
  warning: {
    title: 'Payment issue',
    body: 'We encountered an issue processing your payment. Please try again with the same payment method or choose a different one.',
    showActions: true,
  },
  error: {
    title: 'Oops!',
    body: 'It appears that your card is not valid.',
    showActions: true,
  },
  success: {
    title: 'Email verified',
    body: 'Your email has been verified successfully.',
  },
  loading: {
    title: 'Final step',
    body: "We're in the final step of activation. This usually takes a few minutes. If there are any unforeseen issues, we'll reach out to you via email.",
    showChildren: true,
  },
};

function parseVariant(raw: string | null): StatusIconVariant {
  if (raw && VARIANTS.includes(raw as StatusIconVariant)) {
    return raw as StatusIconVariant;
  }
  return 'loading';
}

/** Dev-only preview of StatusPageLayout variants (scripts/dev-pages.ts). */
const StatusPageLayoutPreview: React.FC = () => {
  const [searchParams] = useSearchParams();
  const variant = parseVariant(searchParams.get('variant'));
  const sample = SAMPLES[variant];

  return (
    <StatusPageLayout
      variant={variant}
      title={sample.title}
      body={sample.body}
      actions={
        sample.showActions ? (
          <>
            <button type="button" className="ev-btn-primary">
              Primary action
            </button>
            <button type="button" className="ev-btn-secondary">
              Secondary action
            </button>
          </>
        ) : undefined
      }
    >
      {sample.showChildren && (
        <a className="ev-link-on-card" href="#preview">
          Example link on card
        </a>
      )}
    </StatusPageLayout>
  );
};

export default StatusPageLayoutPreview;
